import Vue from 'vue';

const GET_SHOP_ORDERS_REPORT_URL = '/report/shop-orders';
const GET_SHOP_PROFIT_REPORT_URL = '/report/shop-profit';

class ReportService {

    async getShopOrdersReport(data) {
        return await Vue.prototype.$axios.post(GET_SHOP_ORDERS_REPORT_URL, data);
    }

    async getShopProfitReport(data) {
        return await Vue.prototype.$axios.post(GET_SHOP_PROFIT_REPORT_URL, data);
    }
}

export default new ReportService();
